module.exports = __webpack_public_path__ + "static/media/apk_icon_white.73474760.svg";